module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'zh-style': _vm.language === 'zh'
    }
  }, [_c('div', {
    attrs: {
      "id": "commission-banner"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('affiliate')))]), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "refer-friends"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('inviteFriends')))]), _vm._v(" "), _c('p', {
    staticClass: "main-num"
  }, [_vm._v(_vm._s(_vm.commissionInfo.inviteNum))]), _vm._v(" "), _c('p', {
    staticClass: "unit"
  }, [_vm._v(_vm._s(_vm.commissionInfo.inviteNum <= 1 ? _vm.$tc('referrals', 1) : _vm.$tc('referrals', 2)))]), _vm._v(" "), _c('p', {
    staticClass: "explain"
  }, [_vm._v(_vm._s(_vm.$t('friendsNumExplain')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "rewards"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('totallyRewards')))]), _vm._v(" "), _c('p', {
    staticClass: "main-num"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.currentSymbol)))]), _vm._v(_vm._s(parseFloat(_vm.commissionInfo.total).toFixed(2)))]), _vm._v(" "), _c('p', {
    staticClass: "explain"
  }, [_vm._v(_vm._s(_vm.$t('commissionExplain'))), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "rewards-details",
    attrs: {
      "to": "/affiliate-program?anchorId=become-affiliate"
    }
  }, [_vm._v(_vm._s(_vm.$t('rewardsRules')))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "withdrawal"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "little-title"
  }, [_vm._v(_vm._s(_vm.$t('withdrawAmount')))]), _vm._v(" "), _c('p', {
    staticClass: "main-num"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t(_vm.currentSymbol)))]), _vm._v(_vm._s(parseFloat(_vm.commissionInfo.balance).toFixed(2)))]), _vm._v(" "), _c('p', {
    staticClass: "explain"
  }, [_vm._v(_vm._s(_vm.$t('withdrawNumExplain'))), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "withdraw-details",
    attrs: {
      "to": "commission/withdraw-details"
    }
  }, [_vm._v(_vm._s(_vm.$t('withdrawDetails')))])], 1), _vm._v(" "), _c('button', {
    staticClass: "withdraw-btn",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#with-draw-modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('withdraw')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content-box",
    attrs: {
      "id": "invite-code-component"
    }
  }, [_c('invite-friend', {
    staticClass: "content ",
    attrs: {
      "invitation-code": _vm.commissionInfo.inviteCode
    }
  })], 1)]), _vm._v(" "), _c('invite-record', {
    staticClass: "invite-record-component",
    attrs: {
      "show-commission": true
    }
  }), _vm._v(" "), _c('withdraw')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f89a8f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/commission/Index.vue
// module id = 1347
// module chunks = 1